module.exports = __webpack_public_path__ + "static/media/geneMet_asthma.0abbef23.png";